import { subscriptionStore } from './subscription.store';

export interface PlusOfferLabel {
  ctaLabel: string;
  trialDays: number;
  expiryLabel: string;
}

const PT_TIMEZONE = 'America/Los_Angeles';

export function formatExpiryInPT(expiresAt: Date): string {
  const date = expiresAt.toLocaleDateString('en-US', {
    timeZone: PT_TIMEZONE,
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
  const time = expiresAt.toLocaleTimeString('en-US', {
    timeZone: PT_TIMEZONE,
    hour: 'numeric',
    minute: '2-digit',
  });
  return `${date} (${time} PT)`;
}

export function usePlusOfferLabel(): PlusOfferLabel | null {
  const offer = subscriptionStore.state.plusPromoOffer;
  if (!offer) return null;

  const expiresAt = new Date(offer.expiresAt);
  if (Number.isNaN(expiresAt.getTime()) || expiresAt <= new Date()) {
    return null;
  }

  return {
    ctaLabel: `Start ${offer.trialDays}-day free trial`,
    trialDays: offer.trialDays,
    expiryLabel: formatExpiryInPT(expiresAt),
  };
}
